// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useRef, useMemo} from 'react';
import styles from './use_case_bubbless.module.less';
import {use_section_scroll} from '../../../../hola/pub/lib/use_section_scroll';
import {Bubbles} from './../toolip/bubbles';
import Icon_box from '../../img/icons/40/box.svg';
import Icon_travel from '../../img/icons/40/travel.svg';
import Icon_smile from '../../img/icons/40/smile.svg';
import Icon_list from '../../img/icons/40/list.svg';
import Icon_ads from '../../img/icons/40/ads.svg';
import Icon_lead from '../../img/icons/40/lead.svg';
import Icon_prices from '../../img/icons/40/prices.svg';
import Icon_market from '../../img/icons/40/market.svg';
import Icon_data from '../../img/icons/40/data.svg';
import Icon_shield from '../../img/icons/40/shield.svg';
import Icon_content from '../../img/icons/40/content.svg';
import Icon_brand from '../../img/icons/40/brand.svg';
import Icon_social from '../../img/icons/40/social.svg';
import Icon_seo from '../../img/icons/40/seo.svg';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';

export const Use_case_bubbless = ({offset_top=-240})=>{
    const {T} = use_translation_v({no_defaults: true});
    const cases = useMemo(()=>{
        const real_b = [{
            id: 'product_dev',
            text: 'Product Development',
            tooltip: `This smooth data collection with proxies helps you
                understand market needs better, making your product development
                more informed, effective and profitable.`,
            tooltip_img: <Icon_box/>,
            link: '/use-cases/product-development',
            blue_bg_hover: true,
        }, {
            id: 'travel',
            text: 'Global Travel Data Comparisons',
            tooltip: `Compare prices with your competition in the travel
                industry and keep your pricing edge. Make sure you always have
                the right promotions running!`,
            tooltip_img: <Icon_travel/>,
            link: '/use-cases/travel',
            blue_bg_hover: true,
        }, {
            id: 'sentiment',
            text: 'Sentiment Analysis',
            tooltip: `Proxies enable you to collect diverse public opinion data
                from various sources. This ensures smooth, uninterrupted data
                collection, making your analysis more accurate and reliable.`,
            tooltip_img: <Icon_smile/>,
            link: '/use-cases/sentiment-analysis',
            blue_bg_hover: true,
        }, {
            id: 'sneakers',
            text: 'Events & Sneakers Access',
            tooltip: `Proxies make snagging the latest sneakers or scoring
                tickets to popular events a breeze. Bypass restrictions and
                access websites faster, get a better chance to grab what you
                want before it sells out.`,
            tooltip_img: <Icon_list/>,
            link: '/use-cases/sneakers',
            blue_bg_hover: true,
        }, {
            id: 'ads',
            text: 'Advertising Optimization',
            tooltip: `Make sure your ads and campaigns are performing as they
                should be, are placed where they are meant to be and getting
                you the results you want.`,
            tooltip_img: <Icon_ads/>,
            link: '/use-cases/ad-verification',
            blue_bg_hover: true,
        }, {
            id: 'leads',
            text: 'Lead Generation',
            tooltip: `Proxies and lead development is the perfect pairing. You
                can identify potential leads more effectively and keep your
                outreach efforts on track.`,
            tooltip_img: <Icon_lead/>,
            link: '/use-cases/lead-generation',
            blue_bg_hover: true,
        }, {
            id: 'prices',
            text: 'Price Monitoring',
            tooltip: `Check how your website is performing globally, at
                anytime. Leads, rankings, engagement metrics — the insights
                are are all at your fingertips.`,
            tooltip_img: <Icon_prices/>,
            link: '/use-cases/price-monitoring',
            blue_bg_hover: true,
        }, {
            id: 'market',
            text: 'Market Research',
            tooltip: `Get more accurate market research with proxies and
                ensure sales optimization by identifying all target audiences
                you can leverage.`,
            tooltip_img: <Icon_market/>,
            link: '/use-cases/',
            blue_bg_hover: true,
        }, {
            id: 'data',
            text: 'Data Scraping',
            tooltip: `Get accurate and trusted data from anywhere on the
                web. Stay ahead of the game, and do it anonymously.`,
            tooltip_img: <Icon_data/>,
            link: '/use-cases/web-scraping',
            blue_bg_hover: true,
        }, {
            id: 'anti_fraud',
            text: 'Anti-Fraud',
            tooltip: `Make sure your product, site, or brand are not being
                used for nefarious purposes. Track this accurately with the
                right data.`,
            tooltip_img: <Icon_shield/>,
            link: '/use-cases/fraud-detection',
            blue_bg_hover: true,
        }, {
            id: 'content',
            text: 'Content Streaming',
            tooltip: `Get IMMEDIATE access to Worldwide streaming, without
                compromising your IP address`,
            tooltip_img: <Icon_content/>,
            link: '/use-cases/',
            blue_bg_hover: true,
        }, {
            id: 'brand',
            text: 'Brand Protection',
            tooltip: `A brand needs protection and optimization. With the right
                data, check both those boxes and win a bigger market share.`,
            tooltip_img: <Icon_brand/>,
            link: '/use-cases/',
            blue_bg_hover: true,
        }, {
            id: 'social',
            text: 'Social Media',
            tooltip: `Manage multiple brands' social media accounts and need
                to ensure smooth access to each page? Multiple IPs guarantee
                smooth connections!`,
            tooltip_img: <Icon_social/>,
            link: '/use-cases/social-media',
            blue_bg_hover: true,
        }, {
            id: 'seo',
            text: 'SEO and SERP',
            tooltip: `Check how your website is performing globally, at
                anytime. Leads, rankings, engagement metrics — the insights
                are are all at your fingertips.`,
            tooltip_img: <Icon_seo/>,
            link: '/use-cases/seo',
            blue_bg_hover: true,
        }];
        return real_b;
    }, []);
    const ref = useRef();
    use_section_scroll(ref, false, {treshold: 0.8});
    const title = <h2 key="title"><T>Free plan for any use case</T></h2>;
    return <section className={styles.use_case_bubbles} ref={ref}>
      <div className={styles.bg}/>
      <div className={styles.container}>
        <Bubbles cases={cases} tile_bg_color="transparent"
          title={title} tile_text_color="neutrals" tooltip_bg_color="pink"
          lines={[
            ['product_dev', 'travel'],
            ['sentiment', 'sneakers', 'ads'],
            ['leads', title, 'prices'],
            ['market', 'data', 'anti_fraud', 'content'],
            ['seo', 'brand', 'social'],
          ]} popup_props={{get_offset_from_screen: true,
            offset_top: offset_top}}
            show_more_el="Show more use cases"
        />
      </div>
    </section>;
};
